
export enum UrlParam {
    QUERY_STRING = "q",
    FILTER_PODCAST_IDS = "podcastIds",
    FILTER_DATE_MONTH = "month",
    FILTER_DATE_YEAR = "year",
    FILTER_DATE = "date",
    SORT_BY = "sort"
}